/*
 * Copyright ©2020. Open Digital Solutions, Novi Sad. Sva prava zadržana.
 * Pravo da se koristi, kopira, modifikuje i distribuira ovaj softver i njegova dokumentacija
 * u bilo koje svrhe, bez naknade ili bez potpisanog sporazuma sa vlasnikom softvera, nije dozvoljeno.
 */

import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { documentSigningNotification } from 'src/models/documentsigningnotification';
import { InternalNotification } from 'src/models/internalNotification.model';

@Injectable({
  providedIn: 'root'
})
export class DataSharingService {
  public newDocument: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public subjectStatusChange: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(null);
  public caseStatusChange: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(null);
  public newSubmission: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public documentSigned: BehaviorSubject<documentSigningNotification> = new BehaviorSubject<documentSigningNotification>(null);
  public acceptedSubmission: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(null);
  public supervisionChangeCase: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(null);
  public notifications: BehaviorSubject<String> = new BehaviorSubject<String>(null);
  public newCase: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public cases: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public internalNotification: BehaviorSubject<InternalNotification> = new BehaviorSubject<InternalNotification>(null);
  public pmnCases: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(null);
  public subjectFamily: BehaviorSubject<any> = new BehaviorSubject<any>(null);

  private centerId = new BehaviorSubject<number>(0);
  castCenterId = this.centerId.asObservable();

   sendCenterId(newCenterId: any) {
      this.centerId.next(newCenterId);
   }
}
